var map = {
	"./10_dp.png": "d1f2",
	"./21.png": "25d8",
	"./2_dp.png": "3001",
	"./3_dp.png": "2b5b",
	"./4_dp.png": "8620",
	"./5_dp.png": "c2c4",
	"./6_dp.png": "5337",
	"./7_dp.png": "a5de",
	"./8_dp.png": "246e",
	"./9_dp.png": "9159",
	"./darren_reddy.png": "bd3f",
	"./horny_mushroom.png": "c085",
	"./horny_mushroom_dead.png": "df48",
	"./light_turner.png": "f405",
	"./light_turner_dead.png": "8a49",
	"./me.png": "b5da",
	"./mr_natas.jpg": "4c18",
	"./sanic.png": "4db1",
	"./sanic_dead.png": "197c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f9a";